import {
    CatalogItemDto,
    ColdTreatmentIndicatorDto,
    ContainerPackageTypeDto,
    ControlledAtmosphereDto,
    FreightCondition,
    PalletPackageTypeDto,
    SpeciesPackageTypeDto,
    VentilationUnitDto,
} from '@opb-workspace/shared';

export function catalogItemName(
    items: CatalogItemDto[],
    id?: number | null,
): string {
    if (id == null) {
        return '';
    }
    return items.find((x) => x.id === id)?.name?.trim() ?? '';
}

export function containerTypeLabel(
    rows: ContainerPackageTypeDto[],
    containerTypeId?: number | null,
    fallbackCode?: string,
): string {
    if (containerTypeId != null) {
        const code = rows.find(
            (x) => x.containerTypeId === containerTypeId,
        )?.code;
        if (code?.trim()) {
            return code.trim();
        }
    }
    return (fallbackCode ?? '').trim();
}

export function palletTypeLabel(
    rows: PalletPackageTypeDto[],
    palletTypeId?: number | null,
    fallbackCode?: string,
): string {
    if (palletTypeId != null) {
        const code = rows.find((x) => x.palletTypeId === palletTypeId)?.code;
        if (code?.trim()) {
            return code.trim();
        }
    }
    return (fallbackCode ?? '').trim();
}

export function coldTreatmentLabel(
    rows: ColdTreatmentIndicatorDto[],
    id?: number | null,
    fallback?: string,
): string {
    if (id != null) {
        const n = rows.find((x) => x.coldTreatmentIndicatorId === id)?.name;
        if (n?.trim()) {
            return n.trim();
        }
    }
    return (fallback ?? '').trim();
}

export function controlledAtmosphereLabel(
    rows: ControlledAtmosphereDto[],
    id?: number | null,
    fallback?: string,
): string {
    if (id != null) {
        const n = rows.find((x) => x.controlledAtmosphereId === id)?.name;
        if (n?.trim()) {
            return n.trim();
        }
    }
    return (fallback ?? '').trim();
}

export function ventilationUnitLabel(
    rows: VentilationUnitDto[],
    id?: number | null,
    fallbackCode?: string,
): string {
    if (id != null) {
        const code = rows.find((x) => x.ventilationUnitId === id)?.code;
        if (code?.trim()) {
            return code.trim();
        }
    }
    return (fallbackCode ?? '').trim();
}

export function speciesPackageTypeLabel(
    rows: SpeciesPackageTypeDto[],
    id?: number | null,
    fallback?: string,
): string {
    if (id != null) {
        const code = rows.find((x) => x.typeOfPackageId === id)?.code;
        if (code?.trim()) {
            return code.trim();
        }
    }
    return (fallback ?? '').trim();
}

const FREIGHT_LABELS: Record<FreightCondition, string> = {
    [FreightCondition.Collect]: 'Collect',
    [FreightCondition.FullCollect]: 'Full collect',
    [FreightCondition.Prepaid]: 'Prepaid',
    [FreightCondition.FullPrepaid]: 'Full prepaid',
};

export function freightConditionLabel(
    fc?: FreightCondition | null,
): string {
    if (fc == null) {
        return '';
    }
    return FREIGHT_LABELS[fc] ?? String(fc);
}

export function yesNo(value: boolean | undefined | null): string {
    if (value === true) {
        return 'Sí';
    }
    if (value === false) {
        return 'No';
    }
    return '';
}
